export default __webpack_public_path__ + "static/media/bg-showcase-5.02c49040.jpg";